import axios from "axios";
import { SNOOZE_NOTIFICATION } from "../utils";

export const snoozeNotification = async () => {
  return await axios.post(SNOOZE_NOTIFICATION);
};
